/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Events_LeadInputs */

const en_features_events_lead = /** @type {(inputs: Features_Events_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group classes with seats.`)
};

const pl_features_events_lead = /** @type {(inputs: Features_Events_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zajęcia grupowe z miejscami.`)
};

/**
* | output |
* | --- |
* | "Group classes with seats." |
*
* @param {Features_Events_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_events_lead = /** @type {((inputs?: Features_Events_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Events_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_events_lead(inputs)
	return en_features_events_lead(inputs)
});